// Quien es administrador de la plataforma, en un solo lugar. Estaba copiado en
// el menu, el Overview, Shipments y SelleGard Freight (entrega 52, revision del
// diff). Es la misma regla que auth.es_admin del backend: `is_admin` o el rol
// `platform_admin`.
export const esAdmin = (user) => Boolean(user?.is_admin || user?.role === 'platform_admin');

export const ROLES_BROKER = ['broker', 'insurance', 'underwriter'];

export const esBroker = (user) => ROLES_BROKER.includes(user?.role);
